<template>
    <template v-if="!generic">
        <SmallHeaderBarPage/>
        <div class="static-header static-header-career">
            <template v-if="questions!==null">
                <template v-if="state==='q1'">
                    <h1 class="static-header-title static-header-title-question">
                        <span class="career-header-game-option" @click="selectOption(1,1)">
                            {{ questions.Frage1.Option1 }}
                        </span>
                        oder
                        <span class="career-header-game-option" @click="selectOption(1,2)">
                            {{ questions.Frage1.Option2 }}
                        </span>?
                    </h1>
                </template>
                <template v-else-if="state==='q2'">
                    <h1 class="static-header-title static-header-title-question">
                        <span class="career-header-game-option" @click="selectOption(2,1)">
                            {{ questions.Frage2.Option1 }}
                        </span>
                        oder
                        <span class="career-header-game-option" @click="selectOption(2,2)">
                            {{ questions.Frage2.Option2 }}
                        </span>?
                    </h1>
                </template>
                <template v-else-if="state==='q3'">
                    <h1 class="static-header-title static-header-title-question">
                        <span class="career-header-game-option" @click="selectOption(3,1)">
                            {{ questions.Frage3.Option1 }}
                        </span>
                        oder
                        <span class="career-header-game-option" @click="selectOption(3,2)">
                            {{ questions.Frage3.Option2 }}
                        </span>?
                    </h1>
                </template>
                <div :class="'career-header-game-answer-container '+(state!=='result'?'inactive':'')">
                    <div class="career-header-game-answer-image"
                         :style="'background-image:url('+getAnswerImage(1)+');'">
                        {{ getAnswer(1) }}
                    </div>
                    <div class="career-header-game-answer-image"
                         :style="'background-image:url('+getAnswerImage(2)+');'">
                        {{ getAnswer(2) }}
                    </div>
                    <div class="career-header-game-answer-image"
                         :style="'background-image:url('+getAnswerImage(3)+');'">
                        {{ getAnswer(3) }}
                    </div>
                    <div class="career-header-game-answer-text">
                        <div class="career-header-game-answer-sentence">
                            Du {{ getSentencePart(1) }}, {{ getSentencePart(2) }} und {{ getSentencePart(3) }}?<br/>
                            Solche Menschen wie Dich brauchen wir im Team bei <span class="medau">MEDAU</span>.
                        </div>
                        <button class="career-header-button" @click="fastApply()">Bist du spontan?</button>
                    </div>
                </div>
            </template>
            <template v-else>
                <LoadingAnimation style="margin:60px 0;"/>
            </template>
            <div v-html="getSVG('arrowLeft')" class="static-header-back" @click="$router.go(-1)"/>
        </div>
    </template>
    <CareerHeaderStatic :question-fallback="false" v-else/>
</template>

<script>
import LoadingAnimation from "@/components/elements/LoadingAnimation.vue";
import SmallHeaderBarPage from "@/components/static/SmallHeaderBarPage.vue";
import CareerHeaderStatic from "@/components/static/CareerHeaderStatic.vue";

export default {
    data() {
        return {
            q1: null,
            q2: null,
            q3: null,
            questions: null,
            generic: false,
        }
    },
    components: {
        SmallHeaderBarPage,
        LoadingAnimation,
        CareerHeaderStatic,
    },
    computed: {
        state() {
            if (this.q1 === null) {
                return 'q1';
            }
            if (this.q2 === null) {
                return 'q2';
            }
            if (this.q3 === null) {
                return 'q3';
            }
            return 'result';
        }
    },
    methods: {
        loadQuestions() {
            this.apiRequest('/career-questions?populate=deep&filters[Aktiv][$eq]=true')
                .then(cnt => {
                    function shuffle(a) {
                        let j, x, i;
                        for (i = a.length - 1; i > 0; i--) {
                            j = Math.floor(Math.random() * (i + 1));
                            x = a[i];
                            a[i] = a[j];
                            a[j] = x;
                        }
                        return a;
                    }

                    if (cnt.data.length > 0) {
                        const entries = cnt.data;
                        const set = cnt.data[Math.floor((Math.random() * entries.length))]?.attributes;
                        const questions = [];
                        questions.push(set.Frage1);
                        questions.push(set.Frage2);
                        questions.push(set.Frage3);
                        shuffle(questions);
                        set.Frage1 = questions[0];
                        set.Frage2 = questions[1];
                        set.Frage3 = questions[2];
                        this.questions = set;
                    } else {
                        this.generic = true;
                    }
                })
                .catch(() => this.generic = true);
        },
        selectOption(q, a) {
            this['q' + q] = a;
        },
        getSentencePart(q) {
            return this.questions["Frage" + q]["Satzteil" + this['q' + q]];
        },
        getAnswer(q) {
            return this.questions["Frage" + q]["Ergebnis" + this['q' + q]];
        },
        getAnswerImage(q) {
            const images = this.questions["Frage" + q]["Bilder" + this['q' + q]]?.data;
            let image = images?.[Math.floor(Math.random() * images?.length)];
            let imageUrl = image?.attributes?.url;
            return this.config.imageBaseUrl + imageUrl;
        },
        fastApply() {
            this.$store.commit("showFastApply", true);
            this.$router.push("#schnellbewerbung");
        },
    },
    mounted() {
        this.loadQuestions();
    }
}
</script>
